const onTimeRmcs = (stats, process = true) => {
  if (process) {
    return stats?.departments?.reduce(
      (value, department) => value + department.nonComplianceReports?.onTime,
      0,
    )
  }

  return stats?.questionnaires?.reduce(
    (value, questionnaire) =>
      value + questionnaire.nonComplianceReports?.onTime,
    0,
  )
}

export default onTimeRmcs
